// frontend/src/utils/acquisition.js
//
// THE one rule for which opaque `?s=` acquisition code a sign-up request
// carries. Both request builders use it - the email door
// (hooks/useSignupDoors.js) and the Google door (services/auth.js
// loginWithGoogle) - so the two can never disagree.
//
// Dependency-free on purpose: the page tests mock services/auth's default
// export, and the hook must keep resolving the code under that mock.

/** sessionStorage key CaptureAcquisition.js writes on landing (first writer wins). */
export const ACQUISITION_SESSION_KEY = "acq_s";

/**
 * The code to attach to a sign-up request: the one this tab captured on
 * landing (sessionStorage 'acq_s', first writer wins -
 * components/CaptureAcquisition.js), else the caller's fallback, else null.
 *
 * REQUEST-TIME ONLY: the fallback is NEVER written to storage, so it cannot
 * mislabel a later visit, a later sign-up or the ad-visitor check. Never
 * throws - unreadable storage counts as "nothing captured".
 *
 * @param {string|null|undefined} [fallback] - e.g. the conversion popup's "k8"
 * @returns {string|null}
 */
export function resolveAcquisitionCode(fallback) {
  let captured = null;
  try {
    captured = sessionStorage.getItem(ACQUISITION_SESSION_KEY) || null;
  } catch (e) {
    captured = null;
  }
  if (captured) return captured;
  return typeof fallback === "string" && fallback ? fallback : null;
}
